module.exports = __webpack_public_path__ + "static/media/Asset 11.d810f293.svg";